import { featureToggleManager } from '@/__core__/feature-toggle/feature-toggle-manager'

/* directive looks like following: v-ft:FEATURE_ID and if feature with corresponding id is toggled then element will be rendered, if not it won't */
export const initFeatureToggleDirective = () => ({
  mounted(element, binding) {
    if (!featureToggleManager.isFeatureActive(binding.value)) {
      element.parentNode.removeChild(element)
    }
  }
})
